import type { UserState, singleElementState } from "@/types";
import { mutations } from "./mutations";
import { actions } from "./actions";
import { getters } from "./getters";

const elementSate: singleElementState<any> = {
  data: {},
  error: null,
  loading: false,
};

export const userState: UserState = {
  user: elementSate,
};

export const UserModule = {
  namespaced: true,
  state: userState,
  getters,
  actions,
  mutations,
};
